import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { QuantityUnit } from '@web/shared/module/measurement';
import { WarehouseProductType } from '../../enums/warehouse-product-type';

@jsonObject
export class WarehouseReceiptProductCreateRequest {
  @jsonMember(String)
  public ownerId!: Guid;

  @jsonMember(String)
  public sku!: string;

  @jsonMember(String)
  public type!: WarehouseProductType;

  @jsonMember(String)
  public batch!: string;

  @jsonMember(String)
  public name!: string;

  @jsonMember(String)
  public durabilityInformation!: string;

  @jsonMember(Number)
  public quantity!: number;

  @jsonMember(String)
  public quantityUnit!: QuantityUnit;

  @jsonMember(String)
  public readonly brand!: string;

  @jsonMember(Boolean)
  public readonly promotion!: boolean;

  public constructor(
    ownerId: Guid,
    sku: string,
    type: WarehouseProductType,
    batch: string,
    name: string,
    brand: string,
    promotion: boolean,
    durabilityInformation: string,
    quantity: number,
    quantityUnit: QuantityUnit,
  ) {
    this.ownerId = ownerId;
    this.sku = sku;
    this.type = type;
    this.batch = batch;
    this.name = name;
    this.brand = brand;
    this.promotion = promotion;
    this.durabilityInformation = durabilityInformation;
    this.quantity = quantity;
    this.quantityUnit = quantityUnit;
  }
}
